import useDeviceType from './useDeviceType';
import { MOBILE_PLACEHOLDER_HEIGHT, DESKTOP_PLACEHOLDER_HEIGHT } from '../constants/index';
import { getExperienceType } from '../utils/product-unavailable-utils';
import { EXPERIENCE_TYPE_GM } from '../constants/base-configuration';

const useGetPlaceholderHeight = (product) => {
  const { isMobile } = useDeviceType();
  const experienceType = getExperienceType(product);
  const heightMap = isMobile ? MOBILE_PLACEHOLDER_HEIGHT : DESKTOP_PLACEHOLDER_HEIGHT;
  // Fall back to the generic (GM) sizes for any unmapped experience type
  return heightMap?.[experienceType] || heightMap?.[EXPERIENCE_TYPE_GM] || {};
};

export default useGetPlaceholderHeight;